import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconIcasas from '../build/icon-icasas'

export const IconIcasas: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconIcasas} />
}

export default IconIcasas
